export const hasWindow = typeof window !== 'undefined'
